import { useFormikContext } from 'formik';

import { RequiredLabel } from '@/components/required-label';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { VoiceOptionContent } from '@/components/voice-option-content';

import { useVoices } from '@/context/VoiceProvider';

import type { AgentCreateFormValues } from '@/schemas/agent.schema';

export const Voices = () => {
  const { voices } = useVoices();

  const { values, setFieldValue, errors, touched } = useFormikContext<AgentCreateFormValues>();
  const selectedVoice = voices.find(voice => voice.id.toString() === values.voice_id?.toString());

  return (
    <>
      <RequiredLabel htmlFor="agent-name">Agent Voice</RequiredLabel>

      <Select
        onValueChange={value => setFieldValue('voice_id', value)}
        value={values.voice_id.toString() || undefined}
      >
        <SelectTrigger
          className={`h-auto min-h-11 w-full py-2 ${
            errors.voice_id && touched.voice_id ? 'border-destructive' : ''
          }`}
          aria-invalid={!!(errors.voice_id && touched.voice_id)}
        >
          {selectedVoice ? (
            <VoiceOptionContent voice={selectedVoice} />
          ) : (
            <span className="text-sm text-muted-foreground">Select a voice</span>
          )}
        </SelectTrigger>
        <SelectContent className="max-h-80">
          {voices.map(voice => {
            return (
              <SelectItem key={voice.voice_id} value={voice.id.toString()} className="py-2">
                <VoiceOptionContent voice={voice} />
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      {errors.voice_id && touched.voice_id && (
        <p className="text-sm text-destructive">{errors.voice_id}</p>
      )}
    </>
  );
};
